import styled, { css } from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';

export const ErrorWrapper = styled.div`
    && {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        aspect-ratio: 1;
        border-radius: 6px;
        background: radial-gradient(
                70.94% 70.94% at 36.73% 29.06%,
                rgba(255, 255, 255, 0.05) 0%,
                rgba(255, 255, 255, 0) 100%
            )
            rgba(255, 255, 255, 0.06);

        user-select: none;
        pointer-events: none;
    }
`;

export const ErrorSquare = styled.div<{ $background?: boolean }>`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;

        ${({ $background }) =>
            $background &&
            css`
                margin-bottom: 8px;
                border-radius: 8px;
                background: ${({ theme }) => theme.shades.black[10]};
            `}
    }
`;

export const ErrorIconWrapper = styled.div`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        opacity: 0.3;
    }
`;

export const ErrorIcon = styled(YatLogo)`
    && {
        margin: 0 auto;
        width: 100%;
        height: 100%;
        fill: white;
    }
`;

export const ErrorText = styled.span`
    && {
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        letter-spacing: -0.1px;
        color: ${({ theme }) => theme.colors.white};
        opacity: 0.5;
    }
`;
